import React from 'react'
import './style.css'
import Menu from '../../components/menu'
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Button from '@material-ui/core/Button';
import Contatos from '../contatos/index'

const Main = () => {
  const tileData = [{
    img: "https://cin.ufpe.br/~mecls/img/on%20food.png",
    title: "OnFood- projeto Programação 1",
    site:"https://github.com/estelasouza/SistemaAlimenticio"

  }, {
    img: "https://cin.ufpe.br/~mecls/img/gincanaGjk.png",
    title: "Site de uma gincana ",
    site:"https://enigmagjk.netlify.app/"

  }, {
    img: "https://cin.ufpe.br/~mecls/img/manipulando%20js%20-1.png",
    title: "Forms de cadastro de pacientes",
    site:"https://github.com/estelasouza/cadastro_pessoas_Tabela_nutricao"

  }, {
    img: "https://cin.ufpe.br/~mecls/img/encasule-se.png",
    title: "Site do encasule-se ",
    site:"https://encasule-se.netlify.app/"

  },
  {
    img: "https://cin.ufpe.br/~mecls/img/conx-peri.jpg",
    title: "Mockup para hackthon",
    site:"https://cin.ufpe.br/~mecls/img/conx-peri.jpg"
  },
  {
    img:"https://firebasestorage.googleapis.com/v0/b/portifolio-b6ea3.appspot.com/o/calculadora.png?alt=media&token=6155dc33-2796-4c9d-9b42-c21f068538c4",
    title:"Calculadora reprograma",
    site:"https://desafio-reprograma-backend-maria-estela-souza.netlify.app/"

  },
  {
    img:"https://firebasestorage.googleapis.com/v0/b/portifolio-b6ea3.appspot.com/o/desafio_react.png?alt=media&token=dc5b914a-eab1-4052-8ba4-d1ad80383c70",
    title:"Desafio React",
    site:"https://github.com/estelasouza/nutcache-challenge-MariaSouza"
  },
  {
    img:"https://firebasestorage.googleapis.com/v0/b/portifolio-b6ea3.appspot.com/o/plataforma_salario.png?alt=media&token=467f7ab9-dd74-45e5-9e2b-001f11e1aecf",
    title:"Plataforma de salários ",
    site:"https://github.com/estelasouza/plataforma_salarios"
  }
  ]
  return (
    <div className="line-row">
      <Menu />

      <div className="row">

        <div className="container">
          <div className="quem-sou-eu">
            <div className="col-sm bg-img">
              <img src="https://firebasestorage.googleapis.com/v0/b/csvcovid.appspot.com/o/IMG_0596.jpeg?alt=media&token=e78d8bad-7374-4e80-9697-546e0f4d1e4d" className="img" />

            </div>
            <div className="col-sm">

              <h1 className="text">Quem sou eu</h1>
              <p className="text">Oie! Tudo bem? Me chamo Maria Estela, sou desenvolvedora web na Databizz e surfista no tempo livre haaha! Amo viajar e 
 conhecer coisas novas, sou apaixonada por tecnologia e toda a contribuição que ela pode trazer para a sociedade!</p>
            </div>



          </div>
        </div>
      </div>

      <div className="projetos">
        <h1 className="text-projeto">Projetos</h1>
        <p className="text-projeto">Alguns dos projetinhos que já desenvolvi na web </p>

        <div className="container">
          <GridList  cellHeight={180}  >

            {tileData.map((tile) => (


              <GridListTile key={tile.img} className="tam-img-apresentacao" >
                <img src={tile.img} alt={tile.title} cols={4} />
                <GridListTileBar
                  title={tile.title}

                  actionIcon={
                    <Button variant="contained" target="_blank" href={tile.site} color="primary">Acessar </Button>
                }
                />
              </GridListTile>
            ))}
          </GridList>

        </div>
      </div>

        <Contatos />
    </div>
  )
}

export default Main